<template>
  <div class="container">
    <div class="bgoverlay">
      <div class="bg" :style="{'background-image': `url(${require('@/assets/images/securitybg2.jpg')})`}"></div>
    </div>
    <div class="inner-pannel">
      <div class="pannel-content">
        <div class="pannel-content-box maxwidth-lg topPoint">
          <!-- <h2></h2> -->
          <div style="height:55px;"></div>
          <div class="content-page">
            <div class="ani animate__animated animate__fadeInUp">
              <el-collapse
                :accordion="true"
                style="width:577px"
              >
                <el-collapse-item :title="$t('responsibilityLanding[0].title')" name="0">
                  <div class="">
                    <div class="left" :class="$i18n.locale=='zh'?'zh-font':'en-font'">
                      <div :class="$i18n.locale=='zh'?'zh-font':'en-font'" style="color:#ffffff;">{{ $t('responsibilityLanding[0].content[0]') }}</div>
                      <div style="height:20px"></div>
                      <div style="color:#ffffff;">{{ $t('responsibilityLanding[0].content[1]') }}</div>
                      <div style="color:#ffffff;">{{ $t('responsibilityLanding[0].content[2]') }}</div>
                      <div style="color:#ffffff;">{{ $t('responsibilityLanding[0].content[3]') }}</div>
                      <div style="color:#ffffff;">{{ $t('responsibilityLanding[0].content[4]') }}</div>
                    </div>
                    <div class="right">
                      <!-- <img src="@/assets/images/hsseq4.png"> -->
                      <img src="@/assets/images/independent2.png">
                    </div>
                  </div>
                  <!-- <div style="height:20px"></div> -->
                </el-collapse-item>
                <el-collapse-item :title="$t('responsibilityLanding[1].title')" name="1">
                  <div class="">
                    <div class="left" :class="$i18n.locale=='zh'?'zh-font':'en-font'">
                      <div :class="$i18n.locale=='zh'?'zh-font':'en-font'" style="color:#ffffff;">{{ $t('responsibilityLanding[1].content[0]') }}</div>
                      <div style="height:20px"></div>
                      <div style="color:#ffffff;">{{ $t('responsibilityLanding[1].content[1]') }}</div>
                      <div style="color:#ffffff;">{{ $t('responsibilityLanding[1].content[2]') }}</div>
                      <div style="color:#ffffff;">{{ $t('responsibilityLanding[1].content[3]') }}</div>
                      <div style="color:#ffffff;">{{ $t('responsibilityLanding[1].content[4]') }}</div>
                    </div>
                    <div class="right">
                      <img src="@/assets/images/independent1.png">
                      <!-- <img src="@/assets/images/hsseq5.jpg"> -->
                    </div>
                  </div>
                </el-collapse-item>
                <el-collapse-item :title="$t('responsibilityLanding[2].title')" name="2">
                  <div class="flex">
                    <div class="left" :class="$i18n.locale=='zh'?'zh-font':'en-font'">
                      <div :class="$i18n.locale=='zh'?'zh-font':'en-font'" style="color:#ffffff;">{{ $t('responsibilityLanding[2].content[0]') }}</div>
                      <div style="color:#ffffff;">{{ $t('responsibilityLanding[2].content[1]') }}</div>
                    </div>
                    <div class="right">
                      <img src="@/assets/images/msds.jpg">
                    </div>
                  </div>  
                </el-collapse-item>
                <el-collapse-item :title="$t('responsibilityLanding[3].title')" name="3">
                  <div class="flex">
                    <div class="left">
                      <div :class="$i18n.locale=='zh'?'zh-font':'en-font'" style="color:#ffffff;">{{ $t('responsibilityLanding[3].content[0]') }}</div>
                      <div style="height:20px"></div>
                      <div :class="$i18n.locale=='zh'?'zh-font':'en-font'" style="color:#ffffff;">{{ $t('responsibilityLanding[3].content[1]') }}</div>
                    </div>
                    <div class="right">
                      <img src="@/assets/images/ncm.png">
                    </div>
                  </div>  
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
    data() {
        return{
        }
    }
}
</script>

<style scoped>
    .inner-pannel{
      min-height: 100%;
      padding-bottom: 54px;
      position: static;
      /* position: relative; */
      /* position: absolute; */
      width: 100%;
    }
    .topPoint::after {
        width: 25px;
        height: 25px;
        content: "";
        position: absolute;
        background: #ed6d00;
        border-radius: 50%;
        z-index: 1;
        top: -12.5px;
        right: -12.5px;
    }
    .content-page .el-collapse{
        width: 100%;
    }
    /deep/ .el-collapse {
      border-bottom: 0;
    }
    /deep/ .el-collapse-item__header{
      color: #ffffff;
    }
    /deep/ .el-collapse-item__wrap{
      padding-left: 0;
    }
    .flex{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .right{
      padding-top: 10px;
      width: 100%;
    }
    .left{
      width: 100%;
    }
    /deep/ .el-collapse-item__wrap{
      border-bottom: 0;
    }
    @media screen and (max-width:768px) {
      .left{
        width: 100%;
      }
      .right{
        width: 100%;
      }
      /deep/ .el-collapse {
        width: 100%!important;
      }
    }
</style>


// WEBPACK FOOTER //
// src/components/responsibilityLanding/responsibilityLanding.vue